//import dependencies (styles, scripts etc)
import '../styles/output.css'
//return a card (For services specifically so as to avoid redundant code in the Services component)
let  Card=({title,src,children,className})=>{
    return(
        <div className={`p-2 m-1 bg-stone-900 w-full max-w-[300px] flex-shrink-0 ${className}`}>
            {/* Image container */}
            <div className={`flex flex-row`}>
                <img src={src} alt='' className={`size-12`}/>
                <div className={`flex flex-col`}>
                    <h3 className='font-semibold text-base text-white text-left ml-2'>{title}</h3>
                    <p className='ml-2 text-white'>{children}</p>
                    <div className='flex flex-col'>
                
            
            </div>
                </div>
                
                </div>
                {/* Description container */}
                
            
        </div>
    )
}
export default Card;
